import React from 'react';
import { Toast as BootstrapToast } from 'react-bootstrap';

const Toast = ({ show, onClose, message, variant = 'success' }) => {
  return (
    <div
      style={{
        position: 'fixed',
        top: 20,
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 9999,
        width: '100%',
        maxWidth: '380px',
        padding: '0 16px'
      }}
    >
      <BootstrapToast 
        show={show} 
        onClose={onClose} 
        delay={3000} 
        autohide
        bg={variant}
        className="w-100 border-0 shadow-sm"
      >
        <BootstrapToast.Body className="text-white d-flex align-items-center">
          <i className="bi bi-check-circle-fill me-2"></i>
          {message}
        </BootstrapToast.Body>
      </BootstrapToast>
    </div>
  );
};

export default Toast; 